import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var FullScreenIcon = function FullScreenIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "FullScreenIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.998 2.736a8 8 0 0 0-.598-.011H11a.725.725 0 0 1 0-1.45h1.426c.258 0 .493 0 .69.016.211.017.441.057.667.172.325.165.589.43.754.754.115.226.155.456.172.667.016.197.016.432.016.69V5a.725.725 0 0 1-1.45 0V3.6c0-.292 0-.467-.011-.598a.6.6 0 0 0-.02-.128.28.28 0 0 0-.118-.118.6.6 0 0 0-.128-.02m.13.02h-.002zm.116.116v.002zM14 10.275c.4 0 .725.325.725.725v1.426c0 .258 0 .493-.016.69a1.8 1.8 0 0 1-.172.667c-.165.325-.43.589-.754.754a1.8 1.8 0 0 1-.667.172c-.197.016-.432.016-.69.016H11a.725.725 0 0 1 0-1.45h1.4c.292 0 .467 0 .598-.011a.6.6 0 0 0 .128-.02.27.27 0 0 0 .118-.118.6.6 0 0 0 .02-.128c.01-.13.011-.306.011-.598V11c0-.4.325-.725.725-.725m-.756 2.853v-.002zm-.116.116h-.002zM3.574 1.275H5a.725.725 0 0 1 0 1.45H3.6c-.292 0-.467 0-.598.011a.6.6 0 0 0-.128.02.28.28 0 0 0-.118.118.6.6 0 0 0-.02.128c-.01.13-.011.306-.011.598V5a.725.725 0 0 1-1.45 0V3.574c0-.258 0-.493.016-.69a1.8 1.8 0 0 1 .172-.667c.165-.325.43-.589.754-.754a1.8 1.8 0 0 1 .667-.172c.197-.016.432-.016.69-.016m-.818 1.597v.002zm.116-.116h.002zM2 10.275c.4 0 .725.325.725.725v1.4c0 .292 0 .467.011.598.007.087.017.12.02.128q.04.077.118.118a.6.6 0 0 0 .128.02c.13.01.306.011.598.011H5a.725.725 0 0 1 0 1.45H3.574c-.258 0-.493 0-.69-.016a1.8 1.8 0 0 1-.667-.172 1.73 1.73 0 0 1-.754-.754 1.8 1.8 0 0 1-.172-.667c-.016-.197-.016-.432-.016-.69V11c0-.4.325-.725.725-.725m.872 2.969h.002zm-.116-.116v-.002z",
      clipRule: "evenodd"
    })
  }));
};

export { FullScreenIcon };
